import TrashIcon from '@mui/icons-material/DeleteOutline'
import ArchiveIcon from '@mui/icons-material/ArchiveOutlined'
import ShareIcon from '@mui/icons-material/ShareOutlined'
import googleSwitch from '/assets/images/googleswitch.jpg'

const GoogleUserSettings = ({ show }) => {
  if (show) return (
    <div className="user-settings">
      <hr/>
      <UsePassAcrossGoogle />
      <GetNotifications />
      <ResponsibilityNote />
      <PassSharingInfo />
      <hr/>
      <ArchivePass />
      <RemovePass />
    </div>
  )
}

const UsePassAcrossGoogle = () => (
  <table>
    <tbody>
      <tr>
        <td>
          <div className="mb-5">
            <div className="header">Use Pass Across Google</div>
            <div className="text">See your pass in places like Maps, Calendar and more</div>
          </div>
        </td>
        <td width={50}>
          <img src={googleSwitch} />
        </td>
      </tr>
    </tbody>
  </table>
)

const GetNotifications = () => (
  <table>
    <tbody>
      <tr>
        <td>
          <div className="mb-5">
            <div className="header">Get notifications for this pass</div>
            <div className="text">Get alerts for pass updates, nearby notifications and linked passes</div>
          </div>
        </td>
        <td width={50}>
          <img src={googleSwitch} />
        </td>
      </tr>
    </tbody>
  </table>
)

const ResponsibilityNote = () => (
  <div className="mb-5">
    <div className="note">The pass provider or merchant is responsible for the info on this pass and may send you notifications. Contact them with any questions.</div>
  </div>
)

const PassSharingInfo = () => (
  <>
    <table>
      <tbody>
        <tr>
          <td><ShareIcon className="icon" /></td>
          <td>
            <div className="mb-5">
              <div className="header">Pass can be shared</div>
              <div className="text">Learn more about sharing with Google Wallet</div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </>
)

const ArchivePass = () => (
  <>
    <ArchiveIcon className="icon" />
    <span className="label">Archive</span>
    <br /><br />
  </>
)

const RemovePass = () => (
  <>
    <TrashIcon className="icon" />
    <span className="label">Remove</span>
    <br /><br />
  </>
)

export default GoogleUserSettings